import React from 'react'
import cn from 'classnames'
import { Loader, Table } from '@web/walter-ui-kit'
import { Column } from '@web/walter-ui-kit/components/Table/types'

import commonStyles from '../style.module.css'
import styles from './style.module.css'
import { tableLang } from '~uikitLang'

const columns: Column[] = [
    {
        key: 'name',
        title: (
            <div className={styles.common}>
                <Loader width={62} height={18} />
            </div>
        ),
        cellClassName: commonStyles.name,
        sortable: false,
        render: () => (
            <>
                <div className={styles.currency}>
                    <div className={styles.icon}>
                        <Loader width={42} height={42} isCircled />
                    </div>
                    <div>
                        <div className={cn(styles.currencyTop, styles.topLine)}>
                            <Loader />
                        </div>
                        <Loader width={40} height={15} />
                    </div>
                </div>
            </>
        ),
    },
    {
        key: 'balance',
        title: (
            <div className={styles.common}>
                <Loader width={62} height={18} />
            </div>
        ),
        align: 'end',
        width: 140,
        cellClassName: commonStyles.balance,
        sortable: false,
        render: () => (
            <div className={styles.balance}>
                <div className={cn(styles.common, styles.topLine)}>
                    <Loader width={62} height={18} />
                </div>
                <Loader width={40} height={15} />
            </div>
        ),
    },
    {
        key: 'percentage',
        title: (
            <div className={styles.common}>
                <Loader width={62} height={18} />
            </div>
        ),
        align: 'end',
        width: 120,
        cellClassName: commonStyles.percentage,
        sortable: false,
        render: () => (
            <div className={styles.common}>
                <Loader width={62} height={18} />
            </div>
        ),
    },
    {
        key: 'frequency',
        title: (
            <div className={styles.common}>
                <Loader width={62} height={18} />
            </div>
        ),
        align: 'end',
        width: 142,
        cellClassName: commonStyles.frequency,
        sortable: false,
        render: () => (
            <div className={styles.common}>
                <Loader width={62} height={18} />
            </div>
        ),
    },
    {
        key: 'actions',
        title: (
            <div className={styles.common}>
                <Loader width={62} height={18} />
            </div>
        ),
        sortable: false,
        align: 'end',
        width: 142,
        cellClassName: commonStyles.actions,
        render: () => (
            <div className={styles.actions}>
                <div className={styles.actionLeft}>
                    <Loader width={32} height={18} />
                </div>
                <div className={styles.actionRight}>
                    <Loader width={32} height={18} />
                </div>
            </div>
        ),
    },
]

function Preloader() {
    return (
        <Table
            dataPointer="staking_table_skeleton"
            columns={columns}
            data={[1, 2, 3]}
            rowClassName={commonStyles.row}
            locales={tableLang}
        />
    )
}

export default Preloader
